<template>
  <div :key="site.id">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'site',
        ]),
    },
    async beforeRouteUpdate(to, from, next) {
        if (from.params.siteId !== to.params.siteId) {
            if (await this.getSiteInfo(to.params.siteId)) {
                next();
            }
        } else {
            next();
        }
    },
    methods: {
        ...mapActions({
            getSiteInfo: 'getSiteInfo',
        }),
    },
};
</script>
